import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNativeCustomTemplate = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 35,
			height: 35,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 3.27295,
			width: 36,
			height: .818182,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 7,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 22,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 26,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 23.6875,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 14,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 18,
			width: 13,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 30,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 10.5,
			width: 30,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 14,
			width: 16,
			height: 14,
			rx: 1,
			fill: "var(--format-icon-color, #A8F0F0)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.0274 18.1158C14.0274 18.1158 14.9674 18.3483 14.9674 18.5508C14.9674 18.7532 14.0274 18.9857 14.0274 18.9857C14.0274 18.9857 13.7949 19.9258 13.5924 19.9258C13.4557 19.9258 13.3267 19.4971 13.2428 19.2187C13.2025 19.0848 13.1727 18.9857 13.1575 18.9857C13.1107 18.9857 12.2174 18.7532 12.2174 18.5508C12.2174 18.3483 13.1575 18.1158 13.1575 18.1158C13.1575 18.1158 13.39 17.1758 13.5924 17.1758C13.7949 17.1758 14.0274 18.1158 14.0274 18.1158ZM10.1923 20.5759C10.1923 20.5759 11.7591 20.9633 11.7591 21.3008C11.7591 21.6382 10.1923 22.0257 10.1923 22.0257C10.1923 22.0257 9.80489 23.5924 9.46745 23.5924C9.23957 23.5924 9.02446 22.8779 8.88478 22.4139C8.81762 22.1908 8.76789 22.0257 8.74256 22.0257C8.66455 22.0257 7.17578 21.6382 7.17578 21.3008C7.17578 20.9633 8.74256 20.5759 8.74256 20.5759C8.74256 20.5759 9.13001 19.0091 9.46745 19.0091C9.80489 19.0091 10.1923 20.5759 10.1923 20.5759ZM14.5091 23.5924C14.5091 23.39 13.569 23.1575 13.569 23.1575C13.569 23.1575 13.3366 22.2174 13.1341 22.2174C12.9317 22.2174 12.6992 23.1575 12.6992 23.1575C12.6992 23.1575 11.7591 23.39 11.7591 23.5924C11.7591 23.7949 12.6524 24.0274 12.6992 24.0274C12.7144 24.0274 12.7442 24.1265 12.7845 24.2603C12.8683 24.5387 12.9974 24.9674 13.1341 24.9674C13.3366 24.9674 13.569 24.0274 13.569 24.0274C13.569 24.0274 14.5091 23.7949 14.5091 23.5924Z",
			fill: "white"
		})
	]
});
export default SvgNativeCustomTemplate;
